import React, { useState } from 'react'
import { Transition } from '@headlessui/react'
import Toggle from '../theme/ThemeToggle'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <nav className="bg-gray-100 dark:bg-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-12">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-900"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {!isOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
          <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex-shrink-0 flex items-center">
              <a href="#about">
                <img
                  className="block lg:hidden h-8 w-auto"
                  src="./M.png"
                  alt="mikydev logo"
                />
              </a>
              <a href="#about">
                <img
                  className="hidden lg:block h-8 w-auto"
                  src="./M.png"
                  alt="mikydev logo"
                />
              </a>
            </div>
            <div className="hidden sm:block sm:ml-6">
              <div className="flex space-x-4">
                <a
                  href="#projects"
                  className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Projects
                </a>
                <a
                  href="#skills"
                  className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Skills
                </a>
                <a
                  target="_blank"
                  href="https://zerok1986.github.io/my-resume-html-css/"
                  className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                  rel="noopener noreferrer"
                >
                  My Resume
                </a>
                <a
                  href="#contact"
                  className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Contact Me
                </a>
                <div className="absolute right-0 top-0 mr-4 mt-2 md:mr-6 md:mt-2">
                  <Toggle />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Transition
        show={isOpen}
        enter="transition ease-out duration-100 transform"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75 transform"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        {(ref) => (
          <div className="sm:hidden" id="mobile-menu">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a
                href="#projects"
                className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                aria-current="page"
              >
                Projects
              </a>

              <a
                href="#skills"
                className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
              >
                Skills
              </a>

              <a
                target="_blank"
                href="https://zerok1986.github.io/my-resume-html-css/"
                className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                rel="noopener noreferrer"
              >
                My Resume
              </a>

              <a
                href="#contact"
                className="text-black dark:text-gray-300 hover:bg-red-900 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
              >
                Contact Me
              </a>
              <div className="absolute right-0 top-0 mr-4 mt-2 md:mr-6 md:mt-2">
                <Toggle />
              </div>
            </div>
          </div>
        )}
      </Transition>
    </nav>
  )
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/layout/Navbar.js